import ImageButtonComponent from '../components/ImageButton/viewer/ImageButton';
import ImageButtonController from '../components/ImageButton/viewer/ImageButton.controller';


const ImageButton = {
  component: ImageButtonComponent,
  controller: ImageButtonController
};


export const components = {
  ['ImageButton']: ImageButton
};

